import React from 'react';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

function UserGuide(props) {
    return (
        <PictureAsPdfOutlinedIcon {...props} />
    );
}

export default UserGuide;